var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "new-page-base",
    {
      staticClass: "page-billing-files",
      attrs: { showBackText: "Faturas" },
      on: {
        back: function($event) {
          _vm.$router.push({ name: "billing-main-page" })
        }
      }
    },
    [
      _c("template", { attrs: { slot: "titleLeft" }, slot: "titleLeft" }, [
        _vm._v("\n    Meus arquivos\n  ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "titleRight" }, slot: "titleRight" },
        [
          _c(
            "router-link",
            {
              staticClass: "button is-primary",
              attrs: { to: { name: "billing-upload-page" } }
            },
            [_vm._v("\n      Adicionar fatura\n    ")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "button",
              attrs: { to: { name: "create-billing-template" } }
            },
            [_vm._v("\n      Criar novo modelo\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "subtitleSection" }, slot: "subtitleSection" },
        [_vm._v("\n    Aqui você encontra todos as faturas adicionadas.\n  ")]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-billing-files__content" },
        [
          _c(
            "sc-tabs",
            {
              staticClass: "is-primary",
              attrs: { size: "is-medium" },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "sc-tab-item",
                {
                  attrs: {
                    id: "billing-files-uploads",
                    label: "Faturas adicionadas"
                  }
                },
                [
                  _c("billing-files-table", {
                    attrs: {
                      files: _vm.billingUploadFiles,
                      loading: _vm.loadingBillingFiles
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-tab-item",
                {
                  attrs: {
                    id: "billing-files-extractions",
                    label: "Faturas exportadas"
                  }
                },
                [
                  _c("billing-extractions-table", {
                    attrs: {
                      files: _vm.billingExtractionFiles,
                      loading: _vm.loadingBillingFiles
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-tab-item",
                {
                  attrs: {
                    id: "billing-files-templates",
                    label: "Modelos de fatura"
                  }
                },
                [
                  _c("billing-templates-table", {
                    attrs: {
                      templates: _vm.clientBillingTemplates,
                      loading: _vm.loadingBillingTemplates
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a112e46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a112e46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/PageMyBillingsFiles.vue
// module id = null
// module chunks = 